import React, { PropsWithChildren, ReactElement, ChangeEvent, useState, useEffect } from "react";
import { checkboxIcon } from "../../../shared/icons";
import styles from "./CustomCheckbox.module.scss";

interface CustomCheckboxProps {
    name: string;
    label: string;
    handleChange: (e: ChangeEvent) => void;
    disabled?: boolean;
}

const CustomCheckbox = (props: PropsWithChildren<CustomCheckboxProps>): ReactElement => {
    const [checked, setChecked] = useState<boolean>(false);

    const handleChange = (e: ChangeEvent): void => {
        setChecked((e.target as HTMLInputElement).checked);
        props.handleChange(e);
    }

    return (
        <div className={styles.customCheckbox}>
            <input
                type="checkbox"
                name={props.name}
                onChange={handleChange}
                disabled={props.disabled ? true : false}
            />

            {checked ? checkboxIcon.checked : checkboxIcon.unchecked}

            <label htmlFor={props.name}>
                {props.label}
            </label>
        </div>
    );
};

export default CustomCheckbox;
